module.exports = __webpack_public_path__ + "a96689f9895149ae169161915a32cba0.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/final-princess-redshoes.svg
// module id = 478
// module chunks = 0